import { categories, categoryMap } from '@/mocks/categories';
import { getArticlesByCategory } from '@/mocks/articles';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import ArticleCard from '@/components/feature/ArticleCard';
import Breadcrumb from '@/components/feature/Breadcrumb';
import ScrollToTop from '@/components/feature/ScrollToTop';

export default function CategoryPage() {
  const { slug } = useParams<{ slug: string }>();
  const navigate = useNavigate();
  const activeCat = slug ? categoryMap[slug] : categories[0];

  const [activeSlug, setActiveSlug] = useState(slug || 'yule');

  useEffect(() => {
    if (slug && categoryMap[slug]) {
      setActiveSlug(slug);
    }
  }, [slug]);

  const displayCat = categoryMap[activeSlug] || categories[0];
  const catArticles = getArticlesByCategory(activeSlug);

  const handleCategoryChange = (newSlug: string) => {
    setActiveSlug(newSlug);
    navigate(`/category/${newSlug}`);
    window.scrollTo({ top: 0, behavior: 'instant' });
  };

  return (
    <div className="min-h-screen bg-background-50">
      <ScrollToTop />
      <Navbar />

      <main className="pt-20 pb-10">
        <div className="max-w-[1280px] mx-auto px-4 md:px-6">
          <Breadcrumb
            items={[
              { label: '首页', href: '/' },
              { label: displayCat.name },
            ]}
          />

          <div className="mb-8">
            <div className="flex items-center gap-3 mb-3">
              <div className="w-10 h-10 flex items-center justify-center rounded-xl bg-primary-100">
                <i className={`${displayCat.icon} text-primary-600 text-xl`}></i>
              </div>
              <div>
                <h1 className="text-xl md:text-2xl font-bold font-heading text-foreground-900">
                  {displayCat.name}
                </h1>
                <p className="text-sm text-secondary-500 mt-0.5">{displayCat.description}</p>
              </div>
            </div>
          </div>

          <div className="flex items-center gap-2 mb-6 overflow-x-auto pb-2">
            {categories.map((cat) => (
              <button
                key={cat.slug}
                onClick={() => handleCategoryChange(cat.slug)}
                className={`px-4 py-2 rounded-full text-sm font-medium whitespace-nowrap transition-all cursor-pointer ${
                  activeSlug === cat.slug
                    ? 'bg-primary-500 text-background-50'
                    : 'bg-secondary-100 text-foreground-700 hover:bg-secondary-200'
                }`}
              >
                {cat.name}
                <span className="ml-1.5 text-xs opacity-70">{cat.articleCount}</span>
              </button>
            ))}
          </div>

          {catArticles.length > 0 ? (
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-5">
              {catArticles.map((article) => (
                <ArticleCard key={article.id} article={article} />
              ))}
            </div>
          ) : (
            <div className="text-center py-20">
              <i className="ri-inbox-line text-5xl text-secondary-300 mb-4 block"></i>
              <p className="text-secondary-500">该分类暂无文章</p>
            </div>
          )}
        </div>
      </main>

      <Footer />
    </div>
  );
}